import { apiClient } from "./client";

export type RiskLevel = "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";

export type BurnoutRow = {
  practitioner_id: string;
  last_name: string;
  first_initial: string | null;
  rpps: string | null;
  window_days: number;
  shifts_total: number;
  night_shifts: number;
  weekend_shifts: number;
  max_consecutive_days: number;
  weighted_hours: number;
  shifts_per_week: number;
  night_shift_pct: number;
  weekend_shift_pct: number;
  score: number;
  risk_level: RiskLevel;
  organization_ids: string[];
};

export async function listBurnoutRisk(
  params: { organization_id?: string; days?: number } = {},
): Promise<BurnoutRow[]> {
  const { data } = await apiClient.get<BurnoutRow[]>("/api/v1/admin/burnout-risk", {
    params,
  });
  return data;
}

export async function getMyBurnoutRisk(days = 30): Promise<BurnoutRow | null> {
  const { data } = await apiClient.get<BurnoutRow | null>(
    "/api/v1/me/burnout-self",
    { params: { days } },
  );
  return data;
}
